"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const withMap_1 = __importDefault(require("./withMap"));
const PolygonComponent = (props) => {
    const { map, data, setPolygonLatLng, setPolygon, options, onClick, resetPolygon } = props;
    const [polygon, setPolygonObject] = react_1.useState();
    react_1.useEffect(() => {
        if (map) {
            setPolygonObject(new google.maps.Polygon());
        }
    }, [map]);
    const handleClick = (e) => {
        onClick && onClick(options);
        resetPolygon && resetPolygon();
    };
    react_1.useEffect(() => {
        if (polygon && map) {
            data.forEach((obj) => {
                setPolygonLatLng && setPolygonLatLng(obj);
            });
            setPolygon && setPolygon(polygon);
            polygon.setPaths(data);
            polygon.setMap(map);
            polygon.addListener('click', handleClick);
        }
        // eslint-disable-next-line
    }, [polygon, data, map]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = withMap_1.default(PolygonComponent);
